module.exports = "<app-widgets-searchbox config=$ctrl.searchConfig placeholder=\"{{ $ctrl.placeholder }}\" value=$ctrl.object show-clear=::$ctrl.showClear> </app-widgets-searchbox> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/search/partial.html
// module id = 493
// module chunks = 0